module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Mask-d77bc1429eb4a2500f1c1cca7bbc200336fb1b368af81acee637d5c694a2e28d.svg";